import { all, fork } from "redux-saga/effects";
//layout
import LayoutSaga from "./layouts/saga";
//Auth
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ResetSaga from "./auth/resetpwd/saga";
import ProfileSaga from "./auth/profile/saga";
import TeamSaga from "./team/saga";
import CompanySaga from "./company/saga";
import ChangePasswordSaga from "./auth/changepwd/saga";
import TenantSettingsSaga from "./tenant-settings/saga";
import ChannelSaga from "./channel/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ResetSaga),
    fork(ProfileSaga),
    fork(TeamSaga),
    fork(CompanySaga),
    fork(ChangePasswordSaga),
    fork(TenantSettingsSaga),
    fork(ChannelSaga),
  ]);
}
